// extracted by mini-css-extract-plugin
export var boxContainer = "osteopathy-module--boxContainer--n2xd8";
export var modesty = "osteopathy-module--modesty--pKz02";
export var title = "osteopathy-module--title--axyji";